import {WlCheckbox} from "./checkbox";
import {defineWebComponent} from "../webcomponents-utils";

export * from './checkbox.component';
export default WlCheckbox;

defineWebComponent('wl-checkbox', WlCheckbox);
